import { useState } from 'react';
import { vacationRequestApi } from '../services/api';
import { toast } from 'sonner';

export function useVacationRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadRequests = async (params) => {
    try {
      setLoading(true);
      setError(null);
      const response = await vacationRequestApi.getAll(params);
      if (response.success && response.data) {
        setRequests(response.data);
      } else {
        throw new Error(response.message || 'Error al cargar solicitudes');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      toast.error('Error al cargar solicitudes: ' + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const createRequest = async (requestData) => {
    const response = await vacationRequestApi.create(requestData);
    if (response.success) {
      setRequests(prev => [response.data, ...prev]);
      toast.success(response.message || 'Solicitud creada exitosamente');
      return { success: true, data: response.data };
    }
    throw new Error(response.message || 'Error al crear solicitud');
  };

  const updateRequestStatus = async (id, status, notes) => {
    const response = await vacationRequestApi.updateStatus(id, { status, notes });
    if (response.success && response.data) {
      setRequests(prev => prev.map(req => (req._id || req.id) === id ? response.data : req));
      toast.success(response.message || `Solicitud ${status === 'approved' ? 'aprobada' : 'rechazada'}`);
      return response.data;
    }
    throw new Error(response.message || 'Error al actualizar solicitud');
  };

  const updateRequest = async (id, updateData) => {
    const response = await vacationRequestApi.update(id, updateData);
    if (response.success && response.data) {
      setRequests(prev => prev.map(req => (req._id || req.id) === id ? response.data : req));
      toast.success(response.message || 'Solicitud actualizada correctamente');
      return response.data;
    }
    throw new Error(response.message || 'Error al actualizar solicitud');
  };

  const deleteRequest = async (id) => {
    const response = await vacationRequestApi.delete(id);
    if (response.success) {
      setRequests(prev => prev.filter(req => (req._id || req.id) !== id));
      toast.success(response.message || 'Solicitud eliminada exitosamente');
      return true;
    }
    throw new Error(response.message || 'Error al eliminar solicitud');
  };

  const getRequestsByEmployee = async (employeeId, params) => {
    const response = await vacationRequestApi.getByEmployee(employeeId, params);
    if (response.success && response.data) {
      // Si response.data tiene la estructura { requests: [...] }, extraer solo requests
      const requests = Array.isArray(response.data) ? response.data : response.data.requests || [];
      return requests;
    }
    toast.error(response.message || 'Error al cargar solicitudes del empleado');
    return [];
  };

  return {
    requests,
    loading,
    error,
    loadRequests,
    createRequest,
    updateRequestStatus,
    updateRequest,
    deleteRequest,
    getRequestsByEmployee
  };
}
